import { ListApiResponse, SingleApiResponse } from '@ianesthesie-kit/services';
import {
  AnesthesiaRisk,
  SurgeryInfo,
  SurgicalEvent,
  SurgicalEventStatus,
  UpcomingSurgery
} from '@/modules/surgicalEvent/surgicalEvent.model';
import axios from 'axios';
import { valueOfEnum } from '@ianesthesie-kit/core';
import { SentryService } from '@ianesthesie-kit/sentry';
import { MedicalDocument, MedicalDocumentType } from '@/modules/document';

export class SurgicalEventService {
  private static readonly INSTANCE: SurgicalEventService =
    new SurgicalEventService();

  private readonly url: string;

  private constructor() {
    this.url = '/bff/patient/surgical-event';
  }

  public static getInstance() {
    return this.INSTANCE;
  }

  public fetchActive(): Promise<SingleApiResponse<SurgicalEvent>> {
    return axios
      .get<SingleApiResponse<SurgicalEvent>>(this.activeUrl())
      .then((r) => r.data)
      .then((r) => ({
        ...r,
        data: {
          ...r.data,
          status: valueOfEnum(r.data?.status, SurgicalEventStatus, {
            throwIfNotFound: false
          })!
        }
      }));
  }

  public fetchActiveSurgeryInfo(): Promise<SingleApiResponse<SurgeryInfo>> {
    return axios
      .get<SingleApiResponse<SurgeryInfo>>(this.activeUrl('/surgery-info'))
      .then((r) => r.data);
  }

  public fetchActiveFollowUpPlans(): Promise<ListApiResponse<UpcomingSurgery>> {
    return axios
      .get<ListApiResponse<UpcomingSurgery>>(this.activeUrl('/follow-up-plan'))
      .then((r) => r.data);
  }

  public fetchActiveAnesthesiaRisks(): Promise<
    SingleApiResponse<AnesthesiaRisk>
  > {
    return axios
      .get<SingleApiResponse<AnesthesiaRisk>>(
        this.activeUrl('/anesthesia/risk')
      )
      .then((r) => r.data);
  }

  public markPrescriptionAsViewed(
    medicalDocument: MedicalDocument
  ): Promise<unknown> {
    if (!medicalDocument) {
      const err = new Error('No medical document provided');
      SentryService.getInstance().captureException(err);
      throw err;
    }

    if (medicalDocument.type !== MedicalDocumentType.GENERIC_PRESCRIPTION) {
      return Promise.resolve();
    }
    return axios.post(
      `/bff/patient/prescription/view?document-id=${medicalDocument.id}`
    );
  }

  private activeUrl(append = ''): string {
    return `${this.url}/active${append}`;
  }
}
